/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useContext } from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
import { getToken, removeUserSession } from "../utils/Auth";
import { LoginCheckService } from "../services/LoginService";
import { useSelector, useDispatch } from "react-redux";
import { setUser, setWidget, unsetWidget, setImage, setUserStatus, setPermission, setGivenPermission, setRegistarationDropDownValues } from "../store/actions/index";
import { MainContext } from "../contexts/MainContext";
import { GetAllPermissions } from "../services/PermissionService";
import PermissionsGate from "../utils/permissionGate";
import { GetAllDropdownValues } from "../services/RegistrationService";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { setState, setStatus } = useContext(MainContext);

  useEffect(() => {
    // PermissionsGate();
    LoginCheckService()
      .then((res) => {
        dispatch(unsetWidget());
        dispatch(setWidget({ status: 1 }));
        res.data.id = res.data.user_id;
        dispatch(setUser(res.data));
        if (res.data.picture_me !== null) {
          dispatch(setImage(res.data.picture_me));
          setState(res.data.picture_me);
        } else {
          dispatch(setImage(""));
        }
        getPermissions(res.data.role_id);
        getRegistrationDropdownValues();
        dispatch(setUserStatus(res.data.Status));
        setStatus(res.data.Status);
      })
      .catch((err) => {
        // No response means the axios interceptor already sent the browser to login with ?redirect=.
        if (err?.response?.status !== 401) {
          return;
        }
        // A rejected session (e.g. an old or invalid token) - clear it, or the login route bounces to /home,
        // and keep the page in ?redirect= so login returns here (e.g. a scanned QR link).
        removeUserSession();
        const fullPath = history.location.pathname + history.location.search + history.location.hash;
        history.push({
          pathname: "/",
          ...(fullPath && fullPath !== "/" && { search: `?redirect=${encodeURIComponent(fullPath)}` }),
          state: { from: history.location }
        });
      });
  }, []);

  const getPermissions = (role_id) => {
    GetAllPermissions(role_id).then((res) => {
      let allPermissions = res && res.data && res.data.allPermissions ? res.data.allPermissions : [];
      let allGivenPermissions = res && res.data && res.data.givenPermissions ? res.data.givenPermissions : [];

      let allPermObj = {};
      let allGivenPermObj = [];
      allPermissions.map((elem, ind) => {
        allPermObj[elem.permission_description] = elem.permission_description;
        allGivenPermissions.map((element, index) => {
          if (element.item_id === elem.permission_id) {
            allGivenPermObj.push(elem.permission_description);
          }
        })
      })
      dispatch(setPermission(allPermObj));
      dispatch(setGivenPermission(allGivenPermObj));

    }).catch((error) => {
      console.error("Error fetching permissions, error");
    })
  }

  function getRegistrationDropdownValues() {
    GetAllDropdownValues().then(res => {
      // console.log("response -=-=-> ", res);
      dispatch(setRegistarationDropDownValues(res && res.data ? res.data : []));
    }).catch(err => {
      console.log("Error fetching default enums ", err);
    })
  }

  const attachRedirectPath = (props) => {
    const fullPath =
      props.location.pathname +
      props.location.search +
      props.location.hash;

    const shouldRedirect =
      fullPath && fullPath !== "/";

    const redirectTo = {
      pathname: "/",
      state: { from: props.location },
      ...(shouldRedirect && {
        search: `?redirect=${encodeURIComponent(fullPath)}`
      })
    };

    return <Redirect to={redirectTo} />;
  };

  return (
    <>
      <main>
        <Route {...rest} render={(props) => (
          getToken()
            ? (
              rest.permission
                ? <PermissionsGate routeCheck={true} scopes={[rest.permission]}>
                  <Component {...props} />
                </PermissionsGate>
                : <Component {...props} />
            )
            : (
              rest.permission
                ? <PermissionsGate routeCheck={true} scopes={[rest.permission]}>
                  <Redirect to={{ pathname: "/", state: { from: props.location } }} />
                </PermissionsGate>
                : attachRedirectPath(props)
            ))
        } />
      </main>
    </>
  );
};

export default PrivateRoute;
